import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { GraficoArea } from '@monorepo-web/components-library';
import { getLayouts } from './layouts';
import BaseGrafico from '../../library/GraficoBase';
import { FormatTypes } from '@monorepo-web/utils';
export default function GraficoEvolucaoPatrimonio(props) {
    const { titulo = 'Evolução do Patrimônio', data, height = 300, moneyPrefix, layout = 'default' } = props;
    const config = getLayouts()[layout];
    return (_jsx(_Fragment, { children: _jsx(BaseGrafico, { titulo: titulo, graphElement: _jsx(GraficoArea, Object.assign({ data: data, tipo: FormatTypes.monetary_extense, moneyPrefix: moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : null, height: height }, config)) }) }));
}
